import { localStorage } from 'app/packages/lib';

import { Theme } from './theme';

const { LocalStorageManager } = localStorage;

export const THEME_STORAGE_KEY = 'theme';
export const SYSTEM_THEME_STORAGE_KEY = 'systemTheme';

export const themeInstance = new LocalStorageManager<Theme>(THEME_STORAGE_KEY);
export const systemThemeInstance = new LocalStorageManager<boolean>(SYSTEM_THEME_STORAGE_KEY);
